import { FC, memo, useEffect, useRef } from 'react'

import { Button } from 'ui/components/Buttons'
import { PageFace, PageV2 } from 'ui/components/Page'

import { CompanyDetailsPageProps } from './CompanyDetailsPageProps'
import {
  AffiliatedCompaniesTable,
  CompanyAdverseMediaCaseTable,
  CompanyAnnualReviewTable,
  CompanyBankAccountsTable,
  CompanyContactsTable,
  CompanyCustomersTable,
  CompanyDocumentsTable,
  CompanyHistoryTable,
  CompanyLicensesTable,
  CompanyQRsTable,
  CompanyVendorsTable,
  GeneralInformation,
  HighRiskReview
} from './components'

export const CompanyDetailsPage: FC<CompanyDetailsPageProps> = memo((props) => {
  const { data, onOpenClientPortalInviteDialog } = props
  const {
    companyName,
    enableInviteUsersToCP,
    showAnnualReviews,
    showAdverseMedia,
    showHighRiskReview,
    showQuarterlyAnalytics
  } = data

  // TODO: move it to provider for all App
  const lastHash = useRef('')

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1)
    }

    if (lastHash.current && document.getElementById(lastHash.current)) {
      setTimeout(() => {
        document.getElementById(lastHash.current)?.scrollIntoView({ behavior: 'smooth', block: 'end' })
        lastHash.current = ''
      }, 0)
    }
  }, [])
  //.end

  return (
    <PageV2
      title="Company Profile"
      face={PageFace.SECONDARY}
      subTitle={companyName || '...'}
      actions={
        enableInviteUsersToCP ? (
          <Button face="inherit white" onClick={onOpenClientPortalInviteDialog}>
            Client Portal Invite
          </Button>
        ) : (
          <Button disabled face="inherit white" title="Not available for consumer accounts">
            Client Portal Invite
          </Button>
        )
      }
    >
      {data && (
        <>
          <GeneralInformation data={data} />
          <CompanyDocumentsTable data={data} />
          <CompanyContactsTable data={data} />
          {showQuarterlyAnalytics && <CompanyQRsTable data={data} />}
          {showHighRiskReview && <HighRiskReview data={data} />}
          <AffiliatedCompaniesTable data={data} />
          <CompanyLicensesTable data={data} />
          <CompanyCustomersTable data={data} />
          <CompanyBankAccountsTable data={data} />
          <CompanyVendorsTable data={data} />
          {showAnnualReviews && <CompanyAnnualReviewTable data={data} />}
          {showAdverseMedia && <CompanyAdverseMediaCaseTable data={data} />}
          <CompanyHistoryTable data={data} />
        </>
      )}
    </PageV2>
  )
})
